import {FormSectionType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'
import introductionField from '../fields/introductionField'
import teamMembersField from '../fields/teamMembersField'
import teamNameField from '../fields/teamNameField'
import teamPhotoField from '../fields/teamPhotoField'

const sectionId: number = 1
const teamInfoSection: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: `${copy?.step || 'Stap'} 2`,
	fields: [
		{
			id: 0,
			parent_id: 0,
			name: 'text',
			channel: 'text',
			text:
				copy?.text?.team ||
				'Deze inhoud zal gepubliceerd worden op jullie actiepagina. Je kan deze later nog aanpassen indien je dit wil.'
		},
		{...teamNameField, id: 1, parent_id: sectionId},
		{...teamMembersField, id: 2, parent_id: sectionId, min: 2, max: 15}, // maximum number of team members
		{...introductionField, id: 3, parent_id: sectionId},
		{...teamPhotoField, id: 4, parent_id: sectionId}
	]
}

export default teamInfoSection
